var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d2110995cf58fdc01086de3be1506731cea2e2a8"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["afterpay-site-next@touchcorp-ul"]={id:"d2110995cf58fdc01086de3be1506731cea2e2a8"};
      